import React from 'react';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: ${props => props.theme.color.grey[2]};
  height: 100%;
  max-width: 100%;
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 auto;
  justify-content: flex-start;
  margin: 0 auto;
  max-width: 1168px;
  padding: 32px 16px 0;
  width: 100%;
`;

const Page = ({ children, style }) => (
  <Container>
    <InnerContainer style={style}>{children}</InnerContainer>
  </Container>
);

export default Page;
